import { Tooltip } from 'antd';
import styled, { css } from 'styled-components';

type StyledTooltipContainerProps = {
    $color: 'primary' | 'secondary';
};

export const StyledTooltip = styled(Tooltip)`
    .ant-tooltip-inner {
        color: var(--color-on-surface);
        background: var(--color-surface);
        padding: 12px;
        border-radius: 12px;
    }
`;

export const StyledTooltipContainer = styled.div<StyledTooltipContainerProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 8px;
    cursor: pointer;

    ${(props) =>
        props.$color === 'primary'
            ? css`
                  background-color: var(--color-primary);
                  color: var(--color-on-primary);
              `
            : css`
                  background-color: var(--color-primary);
                  color: var(--color-on-primary);
              `}
`;
